module.exports = __webpack_public_path__ + "static/img/bg-info.f1d60671.png";